import MouseTrackerPlugin from './mouse-tracker/mouse-tracker.plugin';
import KeyboardTrackerPlugin from './keyboard-tracker/keyboard-tracker.plugin';
import WindowTrackerPlugin from './window-tracker/window-tracker.plugin';
import StorageManagerPlugin from './storage-manager/storage-manager.plugin';

export default {
  install(Vue) {
    Vue.use(MouseTrackerPlugin);
    Vue.use(KeyboardTrackerPlugin);
    Vue.use(WindowTrackerPlugin);
    Vue.use(StorageManagerPlugin);
  },
};
